import { Carousel } from '@xing-com/carousel';
import { ModuleHeader } from '@xing-com/crate-entity-pages-common';
import { CompanyRecommendationCard } from '@xing-com/crate-entity-pages-company-recommendations';

export const CompanyRecommendationCarouselSkeleton: React.FC = () => (
  <Carousel
    itemWidthConfined="50%"
    itemWidth="80%"
    itemWidthWide="280px"
    itemSpacingConfined="16px"
  >
    <CompanyRecommendationCard.Skeleton />
    <CompanyRecommendationCard.Skeleton />
    <CompanyRecommendationCard.Skeleton />
  </Carousel>
);

export const CompanyRecommendationsFallback: React.FC = () => {
  return (
    <div data-testid="loadingContainer">
      <ModuleHeader headlineCopyKey="CP_RECOMMENDS_ADVERTISEMENT_ABOUT_US" />
      <CompanyRecommendationCarouselSkeleton />
    </div>
  );
};
